import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AdminIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "15",
    cy: "7",
    r: "4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M15,13a8.07,8.07,0,0,0-8,6.92,1,1,0,0,0,1,1.15H22a1,1,0,0,0,1-1.15A8.07,8.07,0,0,0,15,13Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M8.47,11.45l-.77-.6c0-.11,0-.23,0-.35a2.07,2.07,0,0,0,0-.35l.76-.6a.17.17,0,0,0,0-.23L7.79,8.08A.19.19,0,0,0,7.56,8l-.89.36A2.62,2.62,0,0,0,6.06,8l-.14-1a.17.17,0,0,0-.17-.15H4.32a.18.18,0,0,0-.18.15L4,8a2.84,2.84,0,0,0-.61.35L2.5,8a.18.18,0,0,0-.22.08L1.56,9.32a.17.17,0,0,0,0,.23l.76.6c0,.12,0,.23,0,.35s0,.24,0,.35l-.76.6a.18.18,0,0,0,0,.23l.72,1.24A.17.17,0,0,0,2.5,13l.89-.36A2.51,2.51,0,0,0,4,13l.14.94a.17.17,0,0,0,.18.15H5.75a.17.17,0,0,0,.18-.15L6.07,13a2.81,2.81,0,0,0,.6-.36l.9.36a.18.18,0,0,0,.22-.08l.72-1.24A.2.2,0,0,0,8.47,11.45ZM5,11.58A1.08,1.08,0,1,1,6.11,10.5,1.07,1.07,0,0,1,5,11.58Z"
  })]
}), 'AdminIcon');